import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { useTable, tableFeatures, rowSelectionFeature, flexRender } from "@tanstack/react-table";

const features = tableFeatures({ rowSelectionFeature });

// Copied from chakra-ui: https://chakra-ui.com/getting-started/with-react-table
export default function DataTable({
  data,
  columns,
  rowSelection,
  getRowId,
  onRowSelectionChange,
  enableMultiRowSelection = false,
}) {
  const table = useTable({
    features,
    columns,
    data,
    enableMultiRowSelection,
    enableRowRangeSelection: false,
    onRowSelectionChange,
    getRowId,
    state: {
      rowSelection,
    },
  });

  return (
    <Table>
      <Thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <Tr key={headerGroup.id}>
            {headerGroup.headers.map((header) => {
              const { meta } = header.column.columnDef;
              return (
                <Th key={header.id} isNumeric={meta?.isNumeric}>
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </Th>
              );
            })}
          </Tr>
        ))}
      </Thead>
      <Tbody>
        {table.getRowModel().rows.map((row) => (
          <Tr key={row.id}>
            {row.getAllCells().map((cell) => {
              const { meta } = cell.column.columnDef;
              return (
                <Td key={cell.id} isNumeric={meta?.isNumeric}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </Td>
              );
            })}
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
